// extracted by mini-css-extract-plugin
module.exports = {"steps":"WizardSteps_steps__20F4A","separator":"WizardSteps_separator__2Q-cd"};